import { am } from './utils';
import Vue from 'vue';
import httpClient from '@/utils/httpClient';
const GET_CONFIGURATIONS = am('GET_CONFIGURATIONS');
const GET_MODEL = am('GET_MODEL');
const GET_TOOL = am('GET_TOOL');
const GET_TOOL_HISTORY = am('GET_TOOL_HISTORY');
const UPDATE_TOOL = am('UPDATE_TOOL');
const DELETE_TOOL_VERSION = am('DELETE_TOOL_VERSION');
const UPSERT_MODEL = am('UPSERT_MODEL');
const DELETE_MODEL = am('DELETE_MODEL');
const GET_STT_SERVICES = am('GET_STT_SERVICES');
const GET_STT_SERVICE = am('GET_STT_SERVICE');
const UPSERT_STT_SERVICE = am('UPSERT_STT_SERVICE');
const DELETE_STT_SERVICE = am('DELETE_STT_SERVICE');
const GET_SKILLS = am('GET_SKILLS');
const GET_SKILL = am('GET_SKILL');
const GET_SKILL_HISTORY = am('GET_SKILL_HISTORY');
const GET_SKILL_FILES = am('GET_SKILL_FILES');
const UPDATE_SKILL = am('UPDATE_SKILL');
const DELETE_SKILL_VERSION = am('DELETE_SKILL_VERSION');
const DELETE_SKILL = am('DELETE_SKILL');

function buildSkillFormData(skill, stagedFiles, newFolders, deletePaths) {
  const formData = new FormData();
  const skillMeta = { ...skill };
  delete skillMeta.stagedFiles;
  delete skillMeta.newFolders;
  delete skillMeta.deletePaths;
  formData.append('skill', JSON.stringify(skillMeta));
  formData.append('deletePaths', JSON.stringify(deletePaths || []));
  formData.append('folders', JSON.stringify(newFolders || []));
  const filesMeta = [];
  if (stagedFiles && stagedFiles.length) {
    stagedFiles.forEach((item, index) => {
      formData.append(`file_${index}`, item.file, item.file.name);
      filesMeta.push({ index, paths: item.destinations });
    });
  }
  formData.append('filesMeta', JSON.stringify(filesMeta));
  return formData;
}

export default {
  namespaced: true,
  state: {
    providers: [],
    sttServiceProviders: [],
    models: [],
    tools: [],
    toolHistory: [],
    sttServices: [],
    contentSources: [],
    variableSelectors: {},
    configurationsPending: false,
    configurationsFailed: false,

    getSttServicesPending: false,
    getSttServicesFailed: false,

    updatePending: false,
    updateFailed: false,

    updateSttServicePending: false,
    updateSttServiceFailed: false,

    deletePending: false,
    deleteFailed: false,

    deleteSttServicePending: false,
    deleteSttServiceFailed: false,

    getModelPending: false,
    getModelFailed: false,

    getToolPending: false,
    getToolFailed: false,

    getToolHistoryPending: false,
    getToolHistoryFailed: false,

    updateToolPending: false,
    updateToolFailed: false,

    deleteToolVersionPending: false,
    deleteToolVersionFailed: false,

    getSttServicePending: false,
    getSttServiceFailed: false,

    skills: [],
    skillHistory: [],
    skillFiles: [],
    getSkillsPending: false,
    getSkillsFailed: false,
    getSkillPending: false,
    getSkillFailed: false,
    getSkillHistoryPending: false,
    getSkillHistoryFailed: false,
    getSkillFilesPending: false,
    getSkillFilesFailed: false,
    updateSkillPending: false,
    updateSkillFailed: false,
    deleteSkillVersionPending: false,
    deleteSkillVersionFailed: false,
    deleteSkillPending: false,
    deleteSkillFailed: false
  },
  getters: {
    getModelById: state => id => {
      return state.models?.find(m => m.id === id);
    },
    chatModels: state => {
      return state.models?.filter(m => m.capability === 'chat' || m.capability === 'chat-with-vision') ?? [];
    },
    imageModels: state => {
      return state.models?.filter(m => m.capability === 'image-generation') ?? [];
    }
  },
  mutations: {
    [GET_CONFIGURATIONS.STARTED](state) {
      state.configurationsFailed = false;
      state.configurationsPending = true;
      state.providers = [];
      state.models = [];
      state.tools = [];
      state.contentSources = [];
    },
    [GET_CONFIGURATIONS.COMPLETED](state, { configurations, variableSelectors, modelPermissions, tools }) {
      state.configurationsPending = false;
      state.models = configurations?.models?.sort((a, b) => a.name.localeCompare(b.name)) ?? [];
      state.tools = (tools ?? []).sort((a, b) => a.name.localeCompare(b.name));
      state.providers = configurations?.providers ?? [];
      state.variableSelectors = variableSelectors ?? {};
      state.modelPermissions = modelPermissions ?? [];
      state.contentSources = configurations?.contentSources ?? ['file'];
    },
    [GET_STT_SERVICES.STARTED](state) {
      state.getSttServicesFailed = false;
      state.getSttServicesPending = true;
      state.sttServiceProviders = [];
      state.sttServices = [];
    },
    [GET_STT_SERVICES.COMPLETED](state, { sttServices, sttServiceProviders }) {
      state.getSttServicesPending = false;
      state.sttServices = sttServices ?? [];
      state.sttServiceProviders = sttServiceProviders ?? [];
    },
    [GET_CONFIGURATIONS.FAILED](state) {
      state.configurationsFailed = true;
      state.configurationsPending = false;
    },
    [GET_STT_SERVICES.FAILED](state) {
      state.getSttServicesFailed = true;
      state.getSttServicesPending = false;
    },
    [UPSERT_MODEL.STARTED](state) {
      state.updateFailed = false;
      state.updatePending = true;
    },
    [UPSERT_STT_SERVICE.STARTED](state) {
      state.updateSttServiceFailed = false;
      state.updateSttServicePending = true;
    },
    [UPSERT_MODEL.COMPLETED](state, { model }) {
      state.updatePending = false;
      var existing = state.models.find(m => m.id == model.id);

      if (existing) {
        var index = state.models.indexOf(existing);
        state.models[index] = model;
      } else {
        state.models.push(model);
      }
    },
    [UPSERT_STT_SERVICE.COMPLETED](state, { sttService }) {
      state.updateSttServicePending = false;
      var existing = state.sttServices.find(s => s.id == sttService.id);

      if (existing) {
        var index = state.sttServices.indexOf(existing);
        state.sttServices[index] = sttService;
      } else {
        state.sttServices.push(sttService);
      }
    },
    [UPSERT_MODEL.FAILED](state) {
      state.updateFailed = true;
      state.updatePending = false;
    },
    [UPSERT_STT_SERVICE.FAILED](state) {
      state.updateSttServiceFailed = true;
      state.updateSttServicePending = false;
    },
    [DELETE_MODEL.STARTED](state) {
      state.deleteFailed = false;
      state.deletePending = true;
    },
    [DELETE_STT_SERVICE.STARTED](state) {
      state.deleteSttServiceFailed = false;
      state.deleteSttServicePending = true;
    },
    [DELETE_MODEL.COMPLETED](state, { id }) {
      state.deletePending = false;
      var existing = state.models.find(m => m.id !== id);

      if (!existing) {
        return;
      }

      var index = state.models.indexOf(existing);
      state.models.splice(index, 1);
    },
    [DELETE_STT_SERVICE.COMPLETED](state, { id }) {
      state.deleteSttServicePending = false;
      var existing = state.sttServices.find(s => s.id !== id);

      if (!existing) {
        return;
      }

      var index = state.sttServices.indexOf(existing);
      state.sttServices.splice(index, 1);
    },
    [DELETE_MODEL.FAILED](state) {
      state.deleteFailed = true;
      state.deletePending = false;
    },
    [DELETE_STT_SERVICE.FAILED](state) {
      state.deleteSttServiceFailed = true;
      state.deleteSttServicePending = false;
    },
    [GET_MODEL.STARTED](state) {
      state.getModelFailed = false;
      state.getModelPending = true;
    },
    [GET_STT_SERVICE.STARTED](state) {
      state.getSttServiceFailed = false;
      state.getSttServicePending = true;
    },
    [GET_MODEL.COMPLETED](state) {
      state.getModelPending = false;
      state.getModelFailed = false;
    },
    [GET_STT_SERVICE.COMPLETED](state) {
      state.getSttServicePending = false;
      state.getSttServiceFailed = false;
    },
    [GET_MODEL.FAILED](state) {
      state.getModelFailed = true;
      state.getModelPending = false;
    },
    [GET_TOOL.STARTED](state) {
      state.getToolFailed = false;
      state.getToolPending = true;
    },
    [GET_TOOL.COMPLETED](state) {
      state.getToolPending = false;
      state.getToolFailed = false;
    },
    [GET_TOOL.FAILED](state) {
      state.getToolFailed = true;
      state.getToolPending = false;
    },
    [GET_TOOL_HISTORY.STARTED](state) {
      state.getToolHistoryFailed = false;
      state.getToolHistoryPending = true;
      state.toolHistory = [];
    },
    [GET_TOOL_HISTORY.COMPLETED](state, { history }) {
      state.getToolHistoryPending = false;
      state.getToolHistoryFailed = false;
      state.toolHistory = history;
    },
    [GET_TOOL_HISTORY.FAILED](state) {
      state.getToolHistoryFailed = true;
      state.getToolHistoryPending = false;
    },
    [UPDATE_TOOL.STARTED](state) {
      state.updateToolFailed = false;
      state.updateToolPending = true;
    },
    [UPDATE_TOOL.COMPLETED](state, { tool }) {
      state.updateToolPending = false;
      const existing = state.tools.find(t => t.name === tool.name);
      if (existing) {
        const index = state.tools.indexOf(existing);
        state.tools[index] = tool;
      }
    },
    [UPDATE_TOOL.FAILED](state) {
      state.updateToolFailed = true;
      state.updateToolPending = false;
    },
    [DELETE_TOOL_VERSION.STARTED](state) {
      state.deleteToolVersionFailed = false;
      state.deleteToolVersionPending = true;
    },
    [DELETE_TOOL_VERSION.COMPLETED](state, { name, version }) {
      state.deleteToolVersionPending = false;
      state.toolHistory = state.toolHistory.filter(h => h.version !== version);
    },
    [DELETE_TOOL_VERSION.FAILED](state) {
      state.deleteToolVersionFailed = true;
      state.deleteToolVersionPending = false;
    },
    [GET_STT_SERVICE.FAILED](state) {
      state.getSttServiceFailed = true;
      state.getSttServicePending = false;
    },
    [GET_SKILLS.STARTED](state) {
      state.getSkillsFailed = false;
      state.getSkillsPending = true;
      state.skills = [];
    },
    [GET_SKILLS.COMPLETED](state, { skills }) {
      state.getSkillsPending = false;
      state.getSkillsFailed = false;
      state.skills = skills;
    },
    [GET_SKILLS.FAILED](state) {
      state.getSkillsFailed = true;
      state.getSkillsPending = false;
    },
    [GET_SKILL.STARTED](state) {
      state.getSkillFailed = false;
      state.getSkillPending = true;
    },
    [GET_SKILL.COMPLETED](state) {
      state.getSkillPending = false;
      state.getSkillFailed = false;
    },
    [GET_SKILL.FAILED](state) {
      state.getSkillFailed = true;
      state.getSkillPending = false;
    },
    [GET_SKILL_HISTORY.STARTED](state) {
      state.getSkillHistoryFailed = false;
      state.getSkillHistoryPending = true;
      state.skillHistory = [];
    },
    [GET_SKILL_HISTORY.COMPLETED](state, { history }) {
      state.getSkillHistoryPending = false;
      state.getSkillHistoryFailed = false;
      state.skillHistory = history;
    },
    [GET_SKILL_HISTORY.FAILED](state) {
      state.getSkillHistoryFailed = true;
      state.getSkillHistoryPending = false;
    },
    [GET_SKILL_FILES.STARTED](state) {
      state.getSkillFilesFailed = false;
      state.getSkillFilesPending = true;
      state.skillFiles = [];
    },
    [GET_SKILL_FILES.COMPLETED](state, { files }) {
      state.getSkillFilesPending = false;
      state.getSkillFilesFailed = false;
      state.skillFiles = files;
    },
    [GET_SKILL_FILES.FAILED](state) {
      state.getSkillFilesFailed = true;
      state.getSkillFilesPending = false;
    },
    [UPDATE_SKILL.STARTED](state) {
      state.updateSkillFailed = false;
      state.updateSkillPending = true;
    },
    [UPDATE_SKILL.COMPLETED](state, { skill }) {
      state.updateSkillPending = false;
      state.updateSkillFailed = false;
      const existing = state.skills.find(s => s.name === skill.name);
      if (existing) {
        const index = state.skills.indexOf(existing);
        Vue.set(state.skills, index, skill);
      } else {
        state.skills.push(skill);
      }
    },
    [UPDATE_SKILL.FAILED](state) {
      state.updateSkillFailed = true;
      state.updateSkillPending = false;
    },
    [DELETE_SKILL_VERSION.STARTED](state) {
      state.deleteSkillVersionFailed = false;
      state.deleteSkillVersionPending = true;
    },
    [DELETE_SKILL_VERSION.COMPLETED](state, { version }) {
      state.deleteSkillVersionPending = false;
      state.skillHistory = state.skillHistory.filter(h => h.version !== version);
    },
    [DELETE_SKILL_VERSION.FAILED](state) {
      state.deleteSkillVersionFailed = true;
      state.deleteSkillVersionPending = false;
    },
    [DELETE_SKILL.STARTED](state) {
      state.deleteSkillFailed = false;
      state.deleteSkillPending = true;
    },
    [DELETE_SKILL.COMPLETED](state, { name }) {
      state.deleteSkillPending = false;
      state.skills = state.skills.filter(s => s.name !== name);
    },
    [DELETE_SKILL.FAILED](state) {
      state.deleteSkillFailed = true;
      state.deleteSkillPending = false;
    }
  },
  actions: {
    async getConfigurations({ commit }) {
      try {
        commit(GET_CONFIGURATIONS.STARTED);
        const configurations = httpClient.get(`/api/v2/nlp/configurations`);
        const variableSelectors = httpClient.get(`/api/v2/nlp/chains/variables/selectors`);
        const modelPermissions = httpClient.get(`/api/v2/nlp/permissions`);
        const tools = httpClient.get(`/api/v2/nlp/tools`);

        var response = await Promise.all([configurations, variableSelectors, modelPermissions, tools]);

        commit(GET_CONFIGURATIONS.COMPLETED, {
          configurations: response[0],
          variableSelectors: response[1],
          modelPermissions: response[2],
          tools: response[3]
        });

        return response;
      } catch (e) {
        commit(GET_CONFIGURATIONS.FAILED);
        throw e;
      }
    },
    async getSttServices({ commit }) {
      try {
        commit(GET_STT_SERVICES.STARTED);
        const sttServices = httpClient.get(`/api/v2/nlp/stt`);
        const sttServiceProviders = httpClient.get(`/api/v2/nlp/stt/providers`);
        var response = await Promise.all([sttServices, sttServiceProviders]);

        commit(GET_STT_SERVICES.COMPLETED, {
          sttServices: response[0],
          sttServiceProviders: response[1]
        });

        return response;
      } catch (e) {
        commit(GET_STT_SERVICES.FAILED);
        throw e;
      }
    },
    async getModel({ commit }, id) {
      try {
        commit(GET_MODEL.STARTED);
        const result = await Promise.all([
          httpClient.get(`/api/v2/nlp/configurations/${id}`),
          httpClient.get(`/api/v2/nlp/permissions/models/${id}/organizations`)
        ]);

        const model = result[0];

        if (model) {
          model.organizations = result[1] ?? [];
        }

        commit(GET_MODEL.COMPLETED);

        return model;
      } catch (e) {
        commit(GET_MODEL.FAILED);
      }
    },
    async getTool({ commit }, name) {
      try {
        commit(GET_TOOL.STARTED);
        const tool = await httpClient.get(`/api/v2/nlp/tools/${encodeURIComponent(name)}`);
        commit(GET_TOOL.COMPLETED);

        return tool;
      } catch (e) {
        commit(GET_TOOL.FAILED);
      }
    },
    async getToolHistory({ commit }, name) {
      try {
        commit(GET_TOOL_HISTORY.STARTED);
        const history = await httpClient.get(`/api/v2/nlp/tools/${encodeURIComponent(name)}/history`);
        const sortedHistory = history.sort((a, b) => b.version - a.version);
        commit(GET_TOOL_HISTORY.COMPLETED, { history: sortedHistory });

        return sortedHistory;
      } catch (e) {
        commit(GET_TOOL_HISTORY.FAILED);
        throw e;
      }
    },
    async updateTool({ commit }, tool) {
      try {
        commit(UPDATE_TOOL.STARTED);
        const updatedTool = await httpClient.patch(`/api/v2/nlp/tools/${encodeURIComponent(tool.name)}`, tool);
        commit(UPDATE_TOOL.COMPLETED, { tool: updatedTool });

        return updatedTool;
      } catch (e) {
        commit(UPDATE_TOOL.FAILED);
        throw e;
      }
    },
    async deleteToolVersion({ commit }, { name, version }) {
      try {
        commit(DELETE_TOOL_VERSION.STARTED);
        await httpClient.delete(`/api/v2/nlp/tools/${encodeURIComponent(name)}/version/${version}`);
        commit(DELETE_TOOL_VERSION.COMPLETED, { name, version });
      } catch (e) {
        commit(DELETE_TOOL_VERSION.FAILED);
        throw e;
      }
    },
    async getSttService({ commit }, id) {
      try {
        commit(GET_STT_SERVICE.STARTED);
        const service = await httpClient.get(`/api/v2/nlp/stt/${id}`);
        commit(GET_STT_SERVICE.COMPLETED);

        return service;
      } catch (e) {
        commit(GET_STT_SERVICE.FAILED);
      }
    },
    async updateModel({ commit }, model) {
      try {
        commit(UPSERT_MODEL.STARTED);
        const organizations = model?.organizations ?? [];
        delete model.organizations;

        const result = await Promise.all([
          httpClient.put(`/api/v2/nlp/configurations/${model.id}`, model),
          httpClient.post(`/api/v2/nlp/permissions/models/${model.id}/organizations`, { organizations })
        ]);

        var model = result[0];
        model.organizations = organizations;

        commit(UPSERT_MODEL.COMPLETED, { model });

        return model;
      } catch (e) {
        commit(UPSERT_MODEL.FAILED);
        throw e;
      }
    },
    async updateSttService({ commit }, sttService) {
      try {
        commit(UPSERT_STT_SERVICE.STARTED);
        const service = await httpClient.put(`/api/v2/nlp/stt/${sttService.id}`, sttService);

        commit(UPSERT_STT_SERVICE.COMPLETED, { sttService: service });

        return service;
      } catch (e) {
        commit(UPSERT_STT_SERVICE.FAILED);
        throw e;
      }
    },
    async createModel({ commit }, model) {
      try {
        commit(UPSERT_MODEL.STARTED);
        const organizations = model?.organizations ?? [];
        delete model.organizations;

        var newModel = await httpClient.post(`/api/v2/nlp/configurations`, model);
        if (organizations?.length && newModel.id) {
          await httpClient.post(`/api/v2/nlp/permissions/models/${newModel.id}/organizations`, { organizations });
        }

        newModel.organizations = organizations;
        commit(UPSERT_MODEL.COMPLETED, { model: newModel });

        return newModel;
      } catch (e) {
        commit(UPSERT_MODEL.FAILED);
        throw e;
      }
    },
    async createSttService({ commit }, sttService) {
      try {
        commit(UPSERT_STT_SERVICE.STARTED);
        var newSttService = await httpClient.post(`/api/v2/nlp/stt`, sttService);
        commit(UPSERT_STT_SERVICE.COMPLETED, { sttService: newSttService });

        return newSttService;
      } catch (e) {
        commit(UPSERT_STT_SERVICE.FAILED);
        throw e;
      }
    },
    async linkModelsToOrganization({ commit }, { id, models }) {
      try {
        commit(UPSERT_MODEL.STARTED);
        var newModel = await httpClient.post(`/api/v2/nlp/permissions/organizations/${id}/models}`, { models });
        commit(UPSERT_MODEL.COMPLETED, { model: newModel });

        return newModel;
      } catch (e) {
        commit(UPSERT_MODEL.FAILED);
        throw e;
      }
    },
    async deleteModel({ commit }, { id }) {
      try {
        commit(DELETE_MODEL.STARTED);
        await httpClient.delete(`/api/v2/nlp/configurations/${id}`);
        commit(DELETE_MODEL.COMPLETED, { id });
      } catch (e) {
        commit(DELETE_MODEL.FAILED);
        throw e;
      }
    },
    async deleteSttService({ commit }, { id }) {
      try {
        commit(DELETE_STT_SERVICE.STARTED);
        await httpClient.delete(`/api/v2/nlp/stt/${id}`);
        commit(DELETE_STT_SERVICE.COMPLETED, { id });
      } catch (e) {
        commit(DELETE_STT_SERVICE.FAILED);
        throw e;
      }
    },
    async getSkills({ commit }) {
      try {
        commit(GET_SKILLS.STARTED);
        const skills = await httpClient.get(`/api/v2/nlp/skills?scope=global`);
        commit(GET_SKILLS.COMPLETED, { skills });
        return skills;
      } catch (e) {
        commit(GET_SKILLS.FAILED);
        throw e;
      }
    },
    async getSkill({ commit }, name) {
      try {
        commit(GET_SKILL.STARTED);
        const skill = await httpClient.get(`/api/v2/nlp/skills/${encodeURIComponent(name)}`);
        commit(GET_SKILL.COMPLETED);
        return skill;
      } catch (e) {
        commit(GET_SKILL.FAILED);
        throw e;
      }
    },
    async getSkillHistory({ commit }, name) {
      try {
        commit(GET_SKILL_HISTORY.STARTED);
        const history = await httpClient.get(`/api/v2/nlp/skills/${encodeURIComponent(name)}/history`);
        const sortedHistory = history.sort((a, b) => b.version - a.version);
        commit(GET_SKILL_HISTORY.COMPLETED, { history: sortedHistory });
        return sortedHistory;
      } catch (e) {
        commit(GET_SKILL_HISTORY.FAILED);
        throw e;
      }
    },
    async getSkillFiles({ commit }, nameOrPayload) {
      const name = typeof nameOrPayload === 'string' ? nameOrPayload : nameOrPayload?.name;
      const version = typeof nameOrPayload === 'object' ? nameOrPayload?.version : undefined;
      try {
        commit(GET_SKILL_FILES.STARTED);
        const url = version
          ? `/api/v2/nlp/skills/${encodeURIComponent(name)}/files?version=${version}`
          : `/api/v2/nlp/skills/${encodeURIComponent(name)}/files`;
        const files = await httpClient.get(url);
        commit(GET_SKILL_FILES.COMPLETED, { files });
        return files;
      } catch (e) {
        commit(GET_SKILL_FILES.FAILED);
        throw e;
      }
    },
    async downloadSkillFile({}, { name, path, version }) {
      const query = new URLSearchParams({ path });
      if (version != null) query.append('version', String(version));
      return httpClient.get(`/api/v2/nlp/skills/${encodeURIComponent(name)}/files/content?${query}`);
    },
    clearSkillFiles({ commit }) {
      commit(GET_SKILL_FILES.COMPLETED, { files: [] });
    },
    async createSkill({ commit }, { skill, stagedFiles, newFolders, deletePaths }) {
      try {
        commit(UPDATE_SKILL.STARTED);
        const formData = buildSkillFormData(skill, stagedFiles, newFolders, deletePaths);
        const createdSkill = await httpClient.post(`/api/v2/nlp/skills`, formData, false, { json: false });
        commit(UPDATE_SKILL.COMPLETED, { skill: createdSkill });
        return createdSkill;
      } catch (e) {
        commit(UPDATE_SKILL.FAILED);
        throw e;
      }
    },
    async updateSkill({ commit }, { name, skill, stagedFiles, newFolders, deletePaths }) {
      try {
        commit(UPDATE_SKILL.STARTED);
        const formData = buildSkillFormData(skill, stagedFiles, newFolders, deletePaths);
        const updatedSkill = await httpClient.put(`/api/v2/nlp/skills/${encodeURIComponent(name)}`, formData, false, { json: false });
        commit(UPDATE_SKILL.COMPLETED, { skill: updatedSkill });
        return updatedSkill;
      } catch (e) {
        commit(UPDATE_SKILL.FAILED);
        throw e;
      }
    },
    async deleteSkillVersion({ commit }, { name, version }) {
      try {
        commit(DELETE_SKILL_VERSION.STARTED);
        await httpClient.delete(`/api/v2/nlp/skills/${encodeURIComponent(name)}/version/${version}`);
        commit(DELETE_SKILL_VERSION.COMPLETED, { name, version });
      } catch (e) {
        commit(DELETE_SKILL_VERSION.FAILED);
        throw e;
      }
    },
    async deleteSkill({ commit }, { name }) {
      try {
        commit(DELETE_SKILL.STARTED);
        await httpClient.delete(`/api/v2/nlp/skills/${encodeURIComponent(name)}`);
        commit(DELETE_SKILL.COMPLETED, { name });
      } catch (e) {
        commit(DELETE_SKILL.FAILED);
        throw e;
      }
    }
  }
};
